import { Link } from "react-router-dom";
import { partnerNormalizationStatusLabel } from "../../../constants/partnerNormalizationReviewConstants";
import {
  formatMileageKm,
  formatPriceCop,
} from "../../../utils/partnerInventoryFormatters";
import { partnerListingDisplayTitle } from "../../../utils/partnerListingDisplay";

function identityLine(listing) {
  return [listing.makeLabel, listing.modelLabel, listing.trimLabel].filter(Boolean).join(" · ") || "—";
}

function rawIdentityLine(listing) {
  return [listing.makeRaw, listing.modelRaw, listing.trimRaw].filter(Boolean).join(" · ");
}

export default function PartnerGroupedListingCard({ listing, dealerId, path, reviewPath }) {
  const title = listing.title || partnerListingDisplayTitle(listing);
  const needsReview =
    listing.normalizationStatus === "partial" || listing.normalizationStatus === "unmatched";
  const rawIdentity = rawIdentityLine(listing);

  return (
    <article className="partner-grouped-listing-card">
      <div className="partner-grouped-listing-card__media">
        {listing.imageUrl ? (
          <img src={listing.imageUrl} alt="" />
        ) : (
          <div className="partner-grouped-listing-card__placeholder">No photo</div>
        )}
      </div>
      <div className="partner-grouped-listing-card__body">
        <h4>{title}</h4>
        <p className="muted partner-grouped-listing-card__meta">
          {listing.year || "—"} · {formatPriceCop(listing.price) || "—"} ·{" "}
          {formatMileageKm(listing.mileage) || "—"}
        </p>
        <p className="partner-grouped-listing-card__meta">
          <span className="partner-normalization-review__source-badge">
            {listing.source === "live" ? "Live ingested" : "Portal-managed"}
          </span>
          {listing.status ? (
            <span className="partner-dealers-badge partner-dealers-badge--managed"> {listing.status}</span>
          ) : null}
          <span
            className={`partner-normalization-review__status partner-normalization-review__status--${listing.normalizationStatus || "unknown"}`}
          >
            {partnerNormalizationStatusLabel(listing.normalizationStatus)}
          </span>
        </p>
        <p className="partner-grouped-listing-card__identity">
          <strong>Canonical:</strong> {identityLine(listing)}
        </p>
        {rawIdentity ? (
          <details className="partner-grouped-listing-card__raw">
            <summary>Raw identity</summary>
            <p className="muted">{rawIdentity}</p>
          </details>
        ) : null}
        <div className="partner-grouped-listing-card__actions">
          <Link className="cv-button-link" to={path(`dealers/${dealerId}/inventory/${listing.id}/edit`)}>
            Edit
          </Link>
          {needsReview ? (
            <Link className="cv-button-link" to={reviewPath}>
              Review
            </Link>
          ) : null}
        </div>
      </div>
    </article>
  );
}
